import React, { memo, ReactElement } from "react";
import { COUPON_BTN_TEST_ID } from "@swiggy-private/cart-test-ids";
import styles from "./TextButton.scss";

interface TextButtonProps {
    ariaLabel?: string | undefined;
    text: string;
    onClick: (e: React.MouseEvent) => void;
}

const TextButton = ({ text, onClick, ariaLabel }: TextButtonProps): ReactElement => {
    return (
        <div
            role="button"
            tabIndex={0}
            aria-label={ariaLabel}
            className={styles.textButton}
            onClick={onClick}
            data-testid={COUPON_BTN_TEST_ID}
        >
            {text}
        </div>
    );
};

export default memo(TextButton);
